import store from "../store/index";
const isHOM = store.getters["app/isHOM"];
const isAndroid = store.getters["app/isAndroid"];
const isIOS = store.getters["app/isIOS"];

export const systemRequest = (methods, data = {}) => {
  console.log("调用参数：", { methods, data },123);
  let model = localStorage.getItem('phoneModel')
  let data_ = {
    methods,
    result: null
  };
  if(model == 'IOS'){
    data_.result = $goIphoneWindow(methods, data)
  }else if(model =='Android'){
    data_.result = $goAndroidWindow(methods, data)
  }else if(model == 'HOM'){
    data_.result = $goHarmonyOSWindow(methods, data)
  }
  return data_;
};

function $goIphoneWindow(methods, data) {
  console.log(methods,'ios');
  if (window.webkit && window.webkit.messageHandlers) {
    let result = window.webkit.messageHandlers[methods].postMessage(
      JSON.stringify(data)
    );
    console.log("我是苹果",result);
    return result;
  }else {
    return false
  }
}

function $goAndroidWindow(methods, data) {
  console.log(methods,data,123);
  if (window.AndroidWebView) {
    let result = window.AndroidWebView[methods](JSON.stringify(data));
    console.log("我是安卓",result);
    return result;
  }else {
    return false
  }
}

function $goHarmonyOSWindow(methods, data) {
  if (window[methods] && window[methods].call) {
    let result = window[methods].call(JSON.stringify(data));

    console.log("我是鸿蒙",result);
    return result;
  }else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/systemFolder/systemService.js